import React from 'react';
import { componentTypes } from '@white-nl/instantsearch-components';
import Picture from "@/js/react/src/components/ui/Picture";

export default function Hit({ hit, results, additionalData }: componentTypes.HitProps) {
  const {
    id,
    title,
    image,
    projectCategories,
    shortDescription,
    excerpt,
  } = hit;

  const {
    hitClasses,
  } = additionalData;

  const hitIndex = results.hits.findIndex((h) => h.id === id);
  // if in slider hitClasses are set
  const lazyLoadImage = hitClasses ? true : hitIndex > 3;
  const selectedCategoryLabel = projectCategories && projectCategories.length > 0 ? projectCategories[0].title ?? '': '';
  const text = shortDescription ?? excerpt ?? '';
  return (
    <div className={`${hitClasses ?? 'w-full'} rounded-2xl flex aspect-square overflow-hidden`}>
      <a
        href={Craft.getSiteUrl(hit.uri, '')}
        className="group/card size-full px-6 pb-6 md:px-10 md:pb-8 relative flex flex-col justify-between no-underline transition-all overflow-hidden rounded-2xl border border-dark/10
                   after:w-full after:h-[65%] after:bottom-0 after:left-0 after:absolute after:bg-blend-linear-burn after:bg-gradient-to-b after:from-black/0 after:to-black/50 after:z-1"
      >
        <div className="relative z-2 flex flex-col gap-2 mt-auto">
          <h4 className="text-light text-lg/8 md:text-3xl/10 font-semibold font-primary">{title}</h4>
          {text &&
            (<div className="text-light text-md/6 md:text-lg/8 font-medium line-clamp-2 max-h-0 group-hover/card:max-h-64 duration-400 overflow-hidden transition-all ease-in-out">{text}</div>)
          }
        </div>
        {selectedCategoryLabel && (
          <div className="w-fit absolute left-6 md:left-10 top-0 px-4 py-1.5 bg-light rounded-bl-md rounded-br-md border-l border-r border-b border-dark/10 inline-flex justify-start items-center z-2">
            <div className="text-gray-500 text-2xs/4 md:text-xs/5 font-normal uppercase tracking-wider">
              {selectedCategoryLabel}
            </div>
          </div>
        )}
        {image && (<Picture
          pictureClasses="block aspect-square flex items-center absolute size-full inset-0 z-0 overflow-hidden"
          image={image}
          classes="size-full"
          defaultTransform="all"
          loading={lazyLoadImage ? 'lazy' : 'eager'}
        />)}
      </a>
    </div>
  );
}
